import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import ButtonPrime from '@/components/navigation/ButtonPrime'
import React from 'react'

export default function LoadingButton({loading, onClick, children}) {
  return (
    <ButtonPrime className={cn('bg-lime-500 text-white')} disabled={loading} onClick={onClick}>
        {loading ? (
            <div>
                <svg className="animate-spin h-5 w-5 mr-3 inline" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A8.001 8.001 0 0112 4V0C6.486 0 2 4.486 2 10h4zm8-2.291A8.001 8.001 0 0120 12h4c0-4.418-3.582-8-8-8v4z"></path>
                </svg>
                {children}
            </div>
        ) : children}
    </ButtonPrime>
  )
}
